import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {InvalidVoucherComponent} from './invalid-voucher.component';

const routes: Routes = [
  {path: 'invalid-voucher', component: InvalidVoucherComponent},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})
export class InvalidVoucherRoutingModule { }
